import React from 'react';

export default function BrandLogo({ className = '' }) {
  return (
    <img
      src="/klart-hemma-logo.png"
      alt="Klart Hemma AB"
      width="2172"
      height="724"
      className={`kh-brand-image ${className}`.trim()}
    />
  );
}
